import React, { useContext, useState, useEffect, useRef } from 'react';
import { AuthContext } from '../contexts/AuthContext';
//https://www.geeksforgeeks.org/reactjs/how-to-change-button-text-on-click-in-reactjs/

const ToggleButton = ({setShowCounty, setShowSearchBar}) => {

    const btnStyle = {
        padding: "10px 20px",
        backgroundColor: "#E3F5DA",
        color: "#283618",
        border: "none",
        borderRadius: "5px",
        cursor: "pointer",
        margin: "10px",
    };

    const { zipCode, updateZipCode } = useContext(AuthContext); // Access zipCode and updateZipCode from AuthContext
    const { countyName, updateCountyName } = useContext(AuthContext); // Access countyName and updateCountyName from AuthContext // Access countyName
    // const [isZipCodeSearched] = useState(!!zipCode);
    // const [isCountyNameSearched] = useState(!!countyName);
    const [buttonText, setButtonText] = useState(countyName ? 'Enter a Zip Code' : 'Enter a County Name');

    const handleClick = () => {
        
        setButtonText(buttonText === 'Enter a County Name' ? 'Enter a Zip Code' : 'Enter a County Name');

        if(buttonText === 'Enter a Zip Code'){

            // updateCountyName('');
            setShowCounty(false);
        }else{

            // updateZipCode('');
            setShowCounty(true);
        }

        setShowSearchBar(false);
    };

    return (

        <div>
            <button style={btnStyle} onClick={handleClick}>
                {buttonText}
                {/* {setShowCounty(false)}   */}
            </button>     
        </div>
    );
};

export default ToggleButton;